import { render, staticRenderFns } from "./MenuLeft.vue?vue&type=template&id=0bea3001&scoped=true"
import script from "./MenuLeft.vue?vue&type=script&lang=js"
export * from "./MenuLeft.vue?vue&type=script&lang=js"
import style0 from "./MenuLeft.vue?vue&type=style&index=0&id=0bea3001&prod&lang=css&scoped=true"
import style1 from "./MenuLeft.vue?vue&type=style&index=1&id=0bea3001&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea3001",
  null
  
)

export default component.exports